import  { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const descriptionService = {
    getAllCategories,
    addCategory,
    updateCategory,
    deleteCategory,
    getDescriptions,
    addDescription,
    deleteDescription,
    updateDescription
};
function getAllCategories() {
    return axios.get('/api/services/app/Description/GetAllCategories', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function addCategory(data)
{
    return axios.post('/api/services/app/Description/AddCategory',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function updateCategory(data)
{
    return axios.put('/api/services/app/Description/UpdateCategory',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function deleteCategory(id)
{
    return axios.delete('/api/services/app/Description/DeleteCategory', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            Id: id
        }
    })
}
function getDescriptions(data) {
    return axios.get('/api/services/app/Description/GetAllDescriptions', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: data
    })
}
function addDescription(data)
{
    return axios.post('/api/services/app/Description/AddNewDescription',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function updateDescription(data)
{
    return axios.put('/api/services/app/Description/UpdateDescription',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function deleteDescription(id)
{
    return axios.delete('/api/services/app/Description/DeleteDescription', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            Id: id
        }
    })
}